import React from 'react';
import { Container, Image } from 'react-bootstrap';
import Slider from 'react-slick';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { BsArrowRight, BsArrowLeft } from "react-icons/bs";
import { ImageUrl } from '../../../../../Helpers/request';

const ShopDiamondShape = () => {
    const data = [
        { title: "Asscher", para: "This unique shape is a square emerald, with linear facets.", image: `${ImageUrl}diamond-shape/asscher-diamond.webp` },
        { title: "Cushion", para: "With soft corners, a beautiful alternative to a round or princess cut.", image: `${ImageUrl}diamond-shape/cushion-diamond.webp` },
        { title: "Emerald", para: "This stylish cut creates rectangular facets with great stone's clarity.", image: `${ImageUrl}diamond-shape/emerald-diamond.webp` },
        { title: "heart", para: "A rare cut that is a true testament of your relationship.", image: `${ImageUrl}diamond-shape/heart-diamond.webp` },
        { title: "Marquise", para: "Elongate the finger of the wearer with a look of great grandeur.", image: `${ImageUrl}diamond-shape/marquise-diamond.webp` },
        { title: "Oval", para: "Optimises carat, giving the illusion of a larger stone.", image: `${ImageUrl}diamond-shape/oval-diamond.webp` },
        { title: "Pear", para: "Combining the brilliance and design of the Round and Marquise cuts.", image: `${ImageUrl}diamond-shape/pear-diamond.webp` },
        { title: "Princess", para: "A contemporary cut, with optimal fire and brilliance.", image: `${ImageUrl}diamond-shape/princess-diamond.webp` },
        { title: "Radiant", para: "The most brilliant of the rectangular cut diamonds.", image: `${ImageUrl}diamond-shape/radiant-diamond.webp` },
        { title: "Round", para: "Cut with the optimum light refraction and sparkle.", image: `${ImageUrl}diamond-shape/round-diamond.webp` },
    ]

    let settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrow: true,
        prevArrow: <button aria-label="arrow"><BsArrowLeft /></button>,
        nextArrow: <button aria-label="arrow"><BsArrowRight /></button>,
        responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
            },
        },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
        beforeChange: (current, next) => {
          document
            .querySelectorAll('.slick-slide[aria-hidden="true"] a, .slick-slide[aria-hidden="true"] button, .slick-slide[aria-hidden="true"] input')
            .forEach(el => el.setAttribute('tabindex', '-1'));
        },
        afterChange: () => {
          document
            .querySelectorAll('.slick-slide:not([aria-hidden="true"]) a, .slick-slide:not([aria-hidden="true"]) button, .slick-slide:not([aria-hidden="true"]) input')
            .forEach(el => el.removeAttribute('tabindex'));
        }
    };

  return (
    <div className='product-bestsale-jewelry product-shape-diamond-slider hidden-xs'>
        <Container>
            <div className="main_heading">
                <h2>Shop Diamonds By Shape</h2>
            </div>
            
            <div className='box-best-seller9'>
                <Slider {...settings}>
                    {
                        data.map((item, index) => <Item key={index} title={item.title} url={item.url} image={item.image} para={item.para} />)   
                    }
                </Slider>

                {/* <div className='ser_btn_sec text-center mt-4'>
                    <Link to='/jewelry' className="btn ser_btn">Shop Engagement Ring</Link>
                </div> */}
            </div>
        </Container>
    </div>
  )
}

const Item = ({ title, url, image, para }) => {
    return (
        <div className='pb_inner item-product'>
            <Link to={url}>
                <div className='product-thumb'>
                    <Image src={image} alt='product' />
                </div>

                <div className='product-info'>
                    <h3 className="title14 product-title">{title}</h3>
                    <p>{para}</p>
                </div>
            </Link>
        </div>
    )
}

export default ShopDiamondShape